module.exports = __webpack_public_path__ + "img/clue02.6c0ee5cb.png";